import { Badge } from "@chakra-ui/react";

export function ContactSalesBadge({
  fontSize,
}: {
  fontSize?: "xs" | "sm" | "md" | "lg";
}) {
  return (
    <Badge colorScheme="purple" fontSize={fontSize}>
      Contact Sales
    </Badge>
  );
}
